<mat-button-toggle
  class="toolbar-button without-checked-state"
  (click)="resetSensorView()"
  [matTooltip]="toolTip$ | async"
>
  <mat-icon [h3CustomIcon]="resetZoomIcon"></mat-icon>
</mat-button-toggle>
